/**
 * Собирает объект `data-*` атрибутов для spread в JSX (`{...buildDataAttributes({...})}`).
 *
 * **Ключи:** если имя не начинается с `data-`, добавляется префикс `data-`
 * (например, `test-id` → `data-test-id`). Ключи уже с префиксом `data-` не дублируются.
 *
 * **Попадают в результат:** `string`, `number`, `boolean` (включая `false` и `0`).
 *
 * **Не попадают:** `undefined` и `null` — соответствующий атрибут в DOM не выставляется.
 *
 * **Булевы значения:** всегда строки `'true'` или `'false'`, не пустая строка и не отсутствие атрибута.
 *
 * **Числа и строки:** приводятся через `String(value)` (`42` → `'42'`).
 */
export function buildDataAttributes(
	attrs: Record<string, string | number | boolean | undefined | null>
): Record<string, string> {
	const result: Record<string, string> = {};

	for (const [key, value] of Object.entries(attrs)) {
		if (value === undefined || value === null) {
			continue;
		}

		const dataKey = key.startsWith('data-') ? key : `data-${key}`;

		if (typeof value === 'boolean') {
			result[dataKey] = value ? 'true' : 'false';
		} else {
			result[dataKey] = String(value);
		}
	}

	return result;
}
